<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <DropFile/>
  </Modal>
</template>

<script>
import Modal from '../../../Shared/Modal.vue';
import DropFile from './DropFile.vue';

export default {
  name: 'UploadWhitelist',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'filters',
    'order',
  ],
  data() {
    return {
      classes: this.class,
    };
  },
  components: {
    Modal,
    DropFile
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
